import { Injectable } from '@angular/core';
import { SocialUser } from '@abacritt/angularx-social-login';

import { Observable, of, map, Subject, mergeAll, merge, tap, shareReplay, BehaviorSubject, combineLatest, catchError, first, concatMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { simulateLogin } from '../interface/simulateLogin';
import { continuousLoginInfo } from '../interface/continuousLoginInfo';
import { studentBadges } from '../interface/studentBadges';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authState$: Observable<SocialUser>;
  sl!: boolean;
  stNo$!: Observable<string>;
  accessToken!: string | undefined;
  continuousLoginInfo$!: Observable<continuousLoginInfo>;
  studentBadges$!: Observable<studentBadges[]>;

  private testLogin = new BehaviorSubject<string | null>(null);
  // private testLogin = new BehaviorSubject<string | null>('B101109066');

  constructor(private httpClient: HttpClient) {



    const testLogin = this.testLogin.pipe(
      map(stno => (stno == null) ? null as unknown as SocialUser : { id: stno, email: stno + '@' } as SocialUser),
    )

    this.authState$ =
      combineLatest([testLogin]).pipe(
        tap(c => console.log(c)),
        map(([t]) => {
          
          return t;
        }),
        shareReplay(1)
      );

    this.stNo$ = this.authState$.pipe(
      map(a => a?.email?.split('@')[0]),
      shareReplay(1),
    );
  }

  // signInWithGoogle() {
  //   return this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  // }

  loginForTesting(stno: string, sl: boolean) {
    this.sl = sl;
    this.testLogin.next(stno);
  }

  simulateLoginDecrypt(encryptStno: string){
    return this.httpClient.get<simulateLogin>(environment.apiUrl + `SimulateLoginDecrypt?d=` + encryptStno, undefined);
  }

  insertLoginRecord(department: string, studentNo: string, name: string){
    let r = this.httpClient.post<continuousLoginInfo>(environment.apiUrl + `InsertLoginRecord?department=` + (department ?? '') + `&studentNo=` + (studentNo ?? '') + `&name=` + (name ?? '') + `&sl=` + (this.sl ? "True" : "False"), undefined);
    this.continuousLoginInfo$ = r.pipe(
      shareReplay(1)
    );
    return r;
  }

  refreshPoints(){
    let r = this.stNo$.pipe(
      concatMap(stno =>
        this.httpClient.post<continuousLoginInfo>(environment.apiUrl + `RefreshPoints?studentNo=` + stno, undefined)
      ));
    this.continuousLoginInfo$ = r.pipe(
      shareReplay(1)
    );
    return r;
  }

  getStudentBadges(studentNo: string){
    let r = this.httpClient.get<studentBadges[]>(environment.apiUrl + `GetStudentBadges?studentNo=` + (studentNo ?? ''), undefined);
    this.studentBadges$ = r.pipe(
      shareReplay(1)
    );
  }

  async signOut() {
    try {
      //await this.authService.signOut();
    } catch (e: any) { }
    finally {
      this.testLogin.next(null);
    }

  }
}


